export default __webpack_public_path__ + "static/GrandSummitBrandPortfolio-0f0c4b3ab24d9eb9645739120747bf62.png";